/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import getResponse from '../utilities/FetchHelper';
import configuration from '../config';

import WithRouter from '../utilities/WithRouter';
import { setCurrentCampus, setCurrentEVData, setCurrentBatteryData } from '../actions';
import ProcessingAndError from '../components/ProcessingAndError';
import EVContent from './subsections/EVContent';
import BatteryContent from './subsections/BatteryContent';
import EditEvGroup from '../components/modals/EditEVGroup';
import EVOverride from '../components/modals/EVOverride';
import EditAllocations from '../components/modals/EditAllocations';
import ConfirmModal from '../components/modals/ConfirmModal';
import BatteryIconNav from '../components/icons/BatteryIconNav';
import EvIconNav from '../components/icons/EvIconNav';
import icon_devices from '../assets/icon_devices.svg';
import icon_battery from '../assets/icon_battery_empty_state.svg';
import { MarketingMessageEv } from '../components/MarketingMessage/MarketingMessageEv';
import { MarketingMessageBattery } from '../components/MarketingMessage/MarketingMessageBattery';

const Devices = ({
  currentCampusId,
  currentEVData,
  updateEVData,
  currentBatteryData,
  updateBatteryData,
  showMobile,
  processing,
  setProcessing,
  errorMessage,
  setErrorMessage,
  router,
}) => {
  const [hasEVs, setHasEvs] = useState(false);
  const [hasBattery, setHasBattery] = useState(false);
  const [powerDecisions, setPowerDecisions] = useState({});
  const [backupResSettings, setBackupResSettings] = useState({});
  const [selectedModal, setSelectedModal] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGXId, setSelectedGXId] = useState(null);
  const [allEVs, setAllEVs] = useState([]);
  const [groupIdDelete, setGroupIdDelete] = useState(null);
  const [modalMessage, setModalMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState('');
  const errorMessageRef = useRef(null);

  const location = useLocation();
  const deviceMenuActive = location.pathname.split('/')[3]?.toLowerCase();

  const powerDecisionsOrder = ['Microgrid', 'Critical', 'Conserve', 'Standard', 'Performance'];

  let initialPowerDecisions;

  function sortedPowerDecisions() {
    let tempPowerDecisions = {};

    currentEVData?.gridInterconnectEvChargers?.map((item) => {
      item?.evChargerGroups.map((group) => {
        initialPowerDecisions = group.powerDecisionLimits;
      });
    });

    powerDecisionsOrder.forEach((key) => {
      if (initialPowerDecisions?.hasOwnProperty(key)) {
        tempPowerDecisions[key] = initialPowerDecisions[key];
      }
    });

    setPowerDecisions(tempPowerDecisions);
  }

  function getAllocationSettings() {
    currentBatteryData?.gridInterconnects.map((battery) => {
      setBackupResSettings({
        high: battery.batteryBackupReservation.highRisk,
        medium: battery.batteryBackupReservation.mediumRisk,
        low: battery.batteryBackupReservation.lowRisk,
        none: battery.batteryBackupReservation.noRisk,
      });
    });
  }

  useEffect(() => {
    if (currentEVData) {
      sortedPowerDecisions();
    }
  }, []);

  //Call device API when campus or nav change
  useEffect(() => {
    if (deviceMenuActive === 'ev') {
      setHasEvs(false);
      updateEVData();
    } else {
      setHasBattery(false);
      updateBatteryData();
    }
  }, [currentCampusId, deviceMenuActive]);

  //When device data updates, reload
  useEffect(() => {
    if (deviceMenuActive === 'ev') {
      if (currentEVData) {
        sortedPowerDecisions();

        // for each currentEVData.gridInterconnectEvChargers, check if evChargerGroups exist
        if (currentEVData.gridInterconnectEvChargers) {
          //check if group has any EVs
          currentEVData.gridInterconnectEvChargers.forEach((interconnect) => {
            if (interconnect.evChargerGroups && interconnect.evChargerGroups.length > 0) {
              interconnect.evChargerGroups.forEach((group) => {
                if (group.evChargers && group.evChargers.length > 0) {
                  setHasEvs(true);
                }
              });
            }
          });
        } else {
          setHasEvs(false);
        }

        let interval = setInterval(() => {
          updateEVData();
        }, 5000);

        return () => clearInterval(interval);
      }
    } else {
      if (currentBatteryData) {
        if (currentBatteryData.gridInterconnects) {
          getAllocationSettings();

          // for each currentBatteryData.gridInterconnects, check if acBatteries exist
          currentBatteryData.gridInterconnects.forEach((interconnect) => {
            if (interconnect.acBatteries && interconnect.acBatteries.length > 0) {
              setHasBattery(true);
            }
          });
        } else {
          setHasBattery(false);
        }

        let interval = setInterval(() => {
          updateBatteryData();
        }, 5000);

        return () => clearInterval(interval);
      }
    }
  }, [currentEVData, currentBatteryData]);

  const clearModal = () => {
    setSelectedModal(null);
  };

  const handleCancelOverride = () => {
    clearModal();
    setProcessing(true);

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        selectedGXId +
        '/gridInterconnect/evChargerGroup/override/' +
        groupIdDelete,
      true,
      'DELETE',
      null,
      updateEVData,
      setProcessing,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
  };

  const handleDelete = () => {
    clearModal();
    setProcessing(true);

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        selectedGXId +
        '/gridInterconnect/evChargerGroup/' +
        groupIdDelete,
      true,
      'DELETE',
      null,
      updateEVData,
      setProcessing,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
  };

  const openEVModal = (selectModal, groupId, action, gxId) => {
    setSelectedGXId(gxId);

    setConfirmAction(action);
    setSelectedModal(selectModal);

    if (selectModal === 'edit-ev' || selectModal === 'override') {
      updateEVData();

      currentEVData.gridInterconnectEvChargers.map((groups) => {
        if (groups.gridInterconnectEntityKey === gxId) {
          setAllEVs([]);

          groups.evChargerGroups.map((group) => {
            group.powerDecisionLimits = powerDecisions;
            group.evChargers.map((charger) => {
              setAllEVs((prevState) => [...prevState, charger]);
            });

            if (groupId !== '') {
              if (group.evChargerGroupId === groupId) {
                setSelectedGroup(group);
              }
            } else {
              setSelectedGroup({
                evChargerGroupName: 'New Group',
                evChargerGroupId: '',
                evChargers: [],
                powerDecisionLimits: {
                  Microgrid: 0,
                  Critical: 0,
                  Conserve: 0,
                  Standard: 0,
                  Performance: 0,
                },
              });
            }
          });
        }
      });
    }

    if (selectModal === 'confirm') {
      setSelectedGXId(gxId);
      setGroupIdDelete(groupId);

      if (action === 'delete') {
        setModalMessage('Are you sure you want to delete this group?');
      } else {
        setModalMessage('Are you sure you want to cancel the override for this group?');
      }
    }
  };

  const openBatteryModal = (selectModal, gxId) => {
    setSelectedGXId(gxId);
    setSelectedModal(selectModal);
  };

  const renderModal = () => {
    switch (selectedModal) {
      case 'edit-ev':
        return (
          <EditEvGroup
            modalImage={icon_devices}
            clearModal={clearModal}
            currentCampusId={currentCampusId}
            currentEVData={currentEVData}
            selectedGXId={selectedGXId}
            selectedGroup={selectedGroup}
            setProcessing={setProcessing}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errorMessageRef={errorMessageRef}
            updateEVData={updateEVData}
            showMobile={showMobile}
            allEVs={allEVs}
          />
        );
      case 'override':
        return (
          <EVOverride
            modalMessage={''}
            modalImage={icon_devices}
            clearModal={clearModal}
            currentCampusId={currentCampusId}
            selectedGXId={selectedGXId}
            selectedGroup={selectedGroup}
            setProcessing={setProcessing}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errorMessageRef={errorMessageRef}
            updateEVData={updateEVData}
            showMobile={showMobile}
          />
        );
      case 'confirm':
        return (
          <ConfirmModal
            modalMessage={modalMessage}
            modalAction={
              confirmAction === 'delete' ? () => handleDelete() : () => handleCancelOverride()
            }
            clearModal={clearModal}
          />
        );
      case 'edit-battery':
        return (
          <EditAllocations
            modalImage={icon_devices}
            clearModal={clearModal}
            backupResSettings={backupResSettings}
            selectedGXId={selectedGXId}
            setProcessing={setProcessing}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errorMessageRef={errorMessageRef}
            updateBatteryData={updateBatteryData}
            showMobile={showMobile}
          />
        );
      default:
        return false;
    }
  };

  const modal = renderModal();

  const renderDeviceIcon = () => {
    if (deviceMenuActive === 'ev') {
      return (
        <EvIconNav
          backgroundFill="none"
          fillColor="#02222B"
          strokeColor={'#02222B'}
          strokeWidth={2.5}
          width="18px"
        />
      );
    } else if (deviceMenuActive === 'battery') {
      return (
        <BatteryIconNav
          backgroundFill="none"
          fillColor="#02222B"
          strokeColor={'#02222B'}
          strokeWidth={2.5}
          width="18px"
        />
      );
    }
  };

  return (
    <DevicesSection className={showMobile ? 'mobile' : 'desktop'}>
      <div className={showMobile ? 'header-container mobile' : 'header-container'}>
        <div className="title-menu">
          <div className="header">
            {renderDeviceIcon()}
            <h1>{deviceMenuActive === 'ev' ? 'EV' : 'Battery'}</h1>
          </div>
        </div>
      </div>

      <section className="devices-section">
        {modal}

        <ProcessingAndError
          processing={processing}
          errorMessage={errorMessage}
          errorMessageRef={errorMessageRef}
        />

        {deviceMenuActive === 'ev' ? (
          <>
            {hasEVs ? (
              <EVContent
                openEVModal={openEVModal}
                showMobile={showMobile}
                currentEVData={currentEVData}
                powerDecisions={powerDecisions}
              />
            ) : (
              <>
                <MarketingMessageEv />
              </>
            )}
          </>
        ) : (
          <>
            {hasBattery ? (
              <BatteryContent
                currentCampusId={currentCampusId}
                currentBatteryData={currentBatteryData}
                openBatteryModal={openBatteryModal}
                showMobile={showMobile}
              />
            ) : (
              <>
                <MarketingMessageBattery />
              </>
            )}
          </>
        )}
      </section>
    </DevicesSection>
  );
};

const DevicesSection = styled.section`
    color: #02222B;
    height: 100vh;
    overflow: auto;

    h3 {
        font-size: 16px;
    }

    .header-container,
    .title-menu {
        align-items: center;
        display: flex;
        justify-content: space-between;
    }

    .title-menu {
        max-width: 350px;
    }

    .header-container {
        nav.devices-navigation {
            display: flex;
            gap: 6px
            justify-content: space-between;
            line-height: 26px;
            margin-left: 24px;

            div {
                border-bottom: 3px transparent solid;
                cursor: pointer;
                font-size: 16px;
                font-weight: 600;
                list-style: none;
                opacity: 0.5;
                text-align: center;
                width: 100px;

                &.active {
                    border-bottom: 3px #9DBECE solid;
                    opacity: 1;
                }
            }
        }
    }

    .devices-section {
        margin-right: 24px;

        .empty-state {
            align-items: center;
            background: #EDF1F2;
            border-radius: 12px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 24px;
            width: clamp(200px, 90%, 550px);

            p {
                font-size: 16px;
                margin: 0;
                text-align: center;
            }

            .icon-copy {
                align-items: center;
                display: flex;
                padding: 24px 0;

                p {
                    text-align: left;
                }
            }

            a {
                background: #02222B;
                border-radius: 8px;
                color: white;
                font-weight: 600;
                padding: 12px 24px;
                transition: ease-in-out 250ms;

                &:hover {
                    background: #02222B95;
                    transition: ease-in-out 250ms;
                }
            }
        }
    }
`;

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentEVData: state.currentEVData,
    currentBatteryData: state.currentBatteryData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentEVData: (evData) => {
      dispatch(setCurrentEVData(evData));
    },
    setCurrentBatteryData: (batteryData) => {
      dispatch(setCurrentBatteryData(batteryData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Devices));
